import React, { useCallback, useEffect, useRef, useState } from 'react';
import { historyHeader, input, lang, graphics, employee } from "../translate";
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-hy';
import 'jquery-ui/ui/i18n/datepicker-ru';
import 'jquery-ui/ui/i18n/datepicker-en-AU';
import Api from "../Api";
import { historyRequest } from "../store/actions/history";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";
import { getHistoryPageSize } from '../helpers/historyPageSize';
import HistorySelect from "./HistorySelect";
import _ from 'lodash';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Select from "react-select";
import { customStyles } from '../helpers/style';
import DispositionSelect from "./new_component/DispositionSelect";
const { REACT_APP_SERVER } = process.env;

function HistoryFilter({ restrictToOwnHistory = false, lockedCaller = '' }) {
    const dateInputStartRef = useRef(null);
    const dateInputEndRef = useRef(null);
    const historyData = useSelector(state => state.history.historyData)
    const historyDataAnswered = useSelector(state => state.history.historyDataAnswered)
    const historyDataAutoCall = useSelector(state => state.history.historyDataAutoCall)
    const location = useLocation();
    const historyStatus = useSelector(state => state.history.historyStatus)
    const navigate = useNavigate();
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const handleChange = useCallback((name, ev) => {
        if (name === 'startTime' || name === 'endTime') {
            setFilters((prev) => ({
                ...prev,
                [name]: ev
            }));
            query[name] = ev
            navigate(`${window.location.pathname}?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`, { replace: true });
        } else {
            setFilters((prev) => ({
                ...prev,
                [name]: ev.target.value,
            }));
            query[name] = ev.target.value
            navigate(`${window.location.pathname}?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`, { replace: true });
        }
    }, [location.search, restrictToOwnHistory])
    useEffect(() => {
        $.datepicker.setDefaults($.datepicker.regional[lang[+localStorage.getItem('atsLang')]]);

        $(dateInputEndRef.current).datepicker({
            dateFormat: 'yy-mm-dd', // Customize the date format
            changeMonth: true,
            changeYear: true,
            defaultDate: '+1w',
        });
        $(dateInputStartRef.current).datepicker({
            dateFormat: 'yy-mm-dd', // Customize the date format
            changeMonth: true,
            changeYear: true,
            defaultDate: '+1w',
        });

        $(dateInputStartRef.current).on('change', function () {
            handleChange('startTime', $(this).val());
        });
        $(dateInputEndRef.current).on('change', function () {
            handleChange('endTime', $(this).val());
        });

    }, [location.search]);
    const [select, setSelect] = useState(true)
    const [array, setArray] = useState(null)
    const dispatch = useDispatch()

    const [showExtraFilters, setShowExtraFilters] = useState(true)
    const [filters, setFilters] = useState({
        startTime: new Date(),
        endTime: new Date(),
        number: '',
        did: '',
        caller: '',
        status: '',
        disposition: '',
        line: '',
        rate: '',
        virtual: '',
    })


    useEffect(() => {
        let yourDate = new Date()
        const offset = yourDate.getTimezoneOffset()
        yourDate = new Date(yourDate.getTime() - (offset * 60 * 1000))
        const forcedCaller = restrictToOwnHistory ? lockedCaller : (query.caller || '');
        if (!_.isEmpty(query)) {
            setFilters({
                endTime: yourDate.toISOString().split('T')[0],
                startTime: yourDate.toISOString().split('T')[0],
                number: query.number || '',
                did: query.did || '',
                caller: forcedCaller,
                status: query.status || '',
                disposition: query.disposition || '',
                line: query.line || '',
                rate: query.rate || '',
                virtual: query.virtual || '',
            })
            if (query.endTime) {
                setFilters((prev) => ({
                    ...prev,
                    endTime: query.endTime
                }))
            }
            if (query.startTime) {
                setFilters((prev) => ({
                    ...prev,
                    startTime: query.startTime
                }))
            }
        } else {
            query.startTime = yourDate.toISOString().split('T')[0]
            query.endTime = yourDate.toISOString().split('T')[0]
            if (restrictToOwnHistory && lockedCaller) query.caller = lockedCaller
            navigate(`?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`);
        }

    }, [restrictToOwnHistory, lockedCaller, location.search])


    const handleSubmit = useCallback(async (ev) => {
        ev.preventDefault()
        const payload = restrictToOwnHistory ? { ...filters, caller: lockedCaller } : { ...filters };
        if (query.member_all === 'true') payload.member_all = true;
        await dispatch(historyRequest(getHistoryPageSize(query.limit), 1, payload));
    }, [filters, restrictToOwnHistory, lockedCaller, query.member_all, query.limit])

    useEffect(() => {
        (async () => {
            try {
                let { data } = await Api.getAllowed()
                if (REACT_APP_SERVER === 'Ucom') {
                    data.inputNumber.sip = data.inputNumber.sip.filter(s => +s.issip === 1)
                }
                setSelect(data.inputNumber)
            } catch (e) {
            }
        })()
    }, [REACT_APP_SERVER]);
    useEffect(() => {
        let resultObjectDis = {}
        let resultObjectLine = {}
        let resultObjectStatus = {}
        let resultObjectIvr = {}
        let resultObjectVoiceMail = {}
        for (let i = 0; i < historyData?.facet_counts?.facet_fields?.status.length; i += 2) {
            const name = historyData?.facet_counts?.facet_fields?.status[i];
            resultObjectStatus[name] = historyData?.facet_counts?.facet_fields?.status[i + 1];
        }
        for (let i = 0; i < historyData?.facet_counts?.facet_fields?.ivr.length; i += 2) {
            const name = historyData?.facet_counts?.facet_fields?.ivr[i];
            resultObjectIvr[name] = historyData?.facet_counts?.facet_fields?.ivr[i + 1];
        }
        for (let i = 0; i < historyData?.facet_counts?.facet_fields?.line.length; i += 2) {
            const name = historyData?.facet_counts?.facet_fields?.line[i];
            resultObjectLine[name] = historyData?.facet_counts?.facet_fields?.line[i + 1];
        }
        for (let i = 0; i < historyData?.facet_counts?.facet_fields?.voiceMail.length; i += 2) {
            const name = historyData?.facet_counts?.facet_fields?.voiceMail[i];
            resultObjectVoiceMail[name] = historyData?.facet_counts?.facet_fields?.voiceMail[i + 1];
        }
        for (let i = 0; i < historyData?.facet_counts?.facet_fields?.disposition.length; i += 2) {
            const name = historyData?.facet_counts?.facet_fields?.disposition[i];
            resultObjectDis[name] = historyData?.facet_counts?.facet_fields?.disposition[i + 1];
        }
        setArray({ disposition: resultObjectDis, line: resultObjectLine, status: resultObjectStatus, ivr: resultObjectIvr, voiceMail: resultObjectVoiceMail })
    }, [historyData]);

    const langIndex = +localStorage.getItem('atsLang') || 1;
    const selectPlaceholder = input.select[langIndex];

    const toLabelString = (x) => {
        if (x == null || x === '') return '';
        if (typeof x === 'string') return x;
        if (typeof x === 'number') return String(x);
        if (typeof x === 'object' && x !== null) {
            const t = x.title ?? x.label ?? x.number;
            return t != null ? toLabelString(t) : '';
        }
        return String(x);
    };

    const virtualOptions = (() => {
        const baseOption = { value: '', label: selectPlaceholder };
        const list = Array.isArray(select?.virtual) ? select.virtual : [];
        return [baseOption, ...list.map(v => {
            const value = v.number ?? v.value ?? v;
            const labelText = toLabelString(v.title ?? v.label ?? value);
            const numberText = v.number != null ? String(v.number) : '';
            const label = numberText ? `${labelText} (${numberText})` : labelText;
            return { value, label: label || selectPlaceholder };
        })];
    })();
    const selectedVirtual = virtualOptions.find(o => +o.value === +filters.virtual) || null;
    const shortsOptions = (() => {
        const baseOption = { value: '', label: selectPlaceholder };
        const list = Array.isArray(select?.shorts) ? select.shorts : [];
        return [baseOption, ...list.map(v => {
            const value = v.number ?? v.value ?? v;
            const labelText = toLabelString(v.title ?? v.label ?? value);
            const numberText = v.number != null ? String(v.number) : '';
            const label = numberText ? `${labelText} (${numberText})` : labelText;
            return { value, label: label || selectPlaceholder };
        })];
    })();
    const selectedShort = shortsOptions.find(o => +o.value === +filters.virtual) || null;

    const statusOptions = [
        { value: '', label: selectPlaceholder },
        { value: 'Incoming Call', label: [graphics['Incoming Call'][langIndex], (filters.status && filters.status !== 'Incoming Call') ? '' : array?.status?.['Incoming Call']].filter(Boolean).join(' ') },
        { value: 'Out Call', label: [graphics['Out Call'][langIndex], (filters.status && filters.status !== 'Out Call') ? '' : array?.status?.['Out Call']].filter(Boolean).join(' ') },
        { value: 'Local Call', label: [graphics['Local Call'][langIndex], (filters.status && filters.status !== 'Local Call') ? '' : array?.status?.['Local Call']].filter(Boolean).join(' ') },
        { value: 'Redirect Call', label: [graphics['Redirect Call'][langIndex], (filters.status && filters.status !== 'Redirect Call') ? '' : array?.status?.['Redirect Call']].filter(Boolean).join(' ') },
        { value: 'Auto Call', label: [graphics['Auto Call'][langIndex], (filters.status && filters.status !== 'Auto Call') ? '' : historyDataAutoCall].filter(Boolean).join(' ') },
        { value: 'Transferred Call', label: [graphics['Transferred Call'][langIndex], (filters.status && filters.status !== 'Transferred Call') ? '' : array?.status?.['Transferred Call']].filter(Boolean).join(' ') },
    ];
    const selectedStatus = statusOptions.find(o => o.value === filters.status) || statusOptions[0];

    const lineOptions = [
        { value: '', label: selectPlaceholder },
        { value: 'IVR', label: [graphics['IVR'][langIndex], (filters.line && filters.line !== 'IVR') ? '' : (historyStatus === "request" ? '' : array?.ivr?.IVR || '')].filter(Boolean).join(' ') },
        { value: 'MusicHold', label: [graphics['Musichold'][langIndex], (filters.line && filters.line !== 'MusicHold') ? '' : array?.line?.MusicHold || ''].filter(Boolean).join(' ') },
        { value: '100097', label: [graphics['VoiceMail'][langIndex], (filters.line && filters.line !== '100097') ? '' : array?.voiceMail?.VoiceMail || ''].filter(Boolean).join(' ') },
    ];
    const selectedLine = lineOptions.find(o => o.value === filters.line) || lineOptions[0];

    const rateOptions = [
        { value: '', label: selectPlaceholder },
        { value: '5', label: '5' },
        { value: '4', label: '4' },
        { value: '3', label: '3' },
        { value: '2', label: '2' },
        { value: '1', label: '1' },
    ];
    const selectedRate = rateOptions.find(o => o.value === filters.rate) || rateOptions[0];

    return (
        <form onSubmit={handleSubmit} className="row" style={{ margin: 2, alignItems: 'start' }}>
            <div className="col-md-11">
                <div className="row history_page">
                    {!restrictToOwnHistory && (
                        <label className="col-md-12">
                            <div className="d-flex align-items-start justify-content-between" style={{ margin: '10px 0', gap: 10 }}>
                                <div className="d-flex align-items-start flex-grow-1" style={{ gap: 10 }}>
                                    <span>{historyHeader.phone[+localStorage.getItem('atsLang') || 1]}</span>
                                    <input value={filters.number} onChange={(ev) => handleChange('number', ev)} style={{ flex: 1 }} />
                                </div>
                                <button type="button"
                                    onClick={() => setShowExtraFilters(prev => !prev)}
                                    style={{
                                        background: '#f3f4f6',
                                        border: '1px solid #ccc',
                                        borderRadius: 6,
                                        padding: '6px 10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        cursor: 'pointer'
                                    }}>
                                    <FilterAltIcon fontSize="small" />
                                </button>
                            </div>
                        </label>
                    )}

                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{historyHeader.start[+localStorage.getItem('atsLang') || 1]}</span>
                            <input
                                ref={dateInputStartRef}
                                type="text"
                                value={query.startTime}
                            />
                        </div>
                    </label>
                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{historyHeader.end[+localStorage.getItem('atsLang') || 1]}</span>
                            <input
                                ref={dateInputEndRef}
                                type="text"
                                value={query.endTime}
                            />
                        </div>
                    </label>
                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{historyHeader.calls[langIndex]}</span>
                            <div style={{ flex: 1 }}>
                                <Select
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={customStyles}
                                    value={selectedStatus}
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    onChange={(opt) => handleChange('status', { target: { value: opt?.value || '' } })}
                                    options={statusOptions}
                                />
                            </div>
                        </div>
                    </label>
                    {!restrictToOwnHistory && (
                        <label className="col-md-4">
                            <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                                <span>{historyHeader.virtual[+localStorage.getItem('atsLang') || 1]}</span>
                                <Select
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={customStyles}
                                    value={[
                                        { value: '', label: selectPlaceholder },
                                        ...(select?.provider || []).map(s => ({ value: String(s.number), label: `${s.number} ${s.name || ''}` })),
                                        ...(select?.fix_provider || []).map(s => ({ value: String(s.number), label: `${s.number} ${s.name || ''}` }))
                                    ].find(opt => opt.value === String(filters.did || '')) || null}
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    onChange={(opt) => handleChange('did', { target: { value: opt?.value || '' } })}
                                    options={[
                                        { value: '', label: selectPlaceholder },
                                        ...(select?.provider || []).map(s => ({ value: String(s.number), label: `${s.number} ${s.name || ''}` })),
                                        ...(select?.fix_provider || []).map(s => ({ value: String(s.number), label: `${s.number} ${s.name || ''}` }))
                                    ]}
                                />
                            </div>
                        </label>
                    )}
                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{historyHeader.status[+localStorage.getItem('atsLang') || 1]}</span>
                            <DispositionSelect
                                graphics={graphics}
                                input={input}
                                countsAnswered={historyDataAnswered?.ANSWERED}
                                counts={array?.disposition}
                                filters={filters}
                                setFilters={handleChange}
                            />
                        </div>
                    </label>
                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{historyHeader.call_stop[langIndex]}</span>
                            <div style={{ flex: 1 }}>
                                <Select
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={customStyles}
                                    value={selectedLine}
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    onChange={(opt) => handleChange('line', { target: { value: opt?.value || '' } })}
                                    options={lineOptions}
                                />
                            </div>
                        </div>
                    </label>
                    {!restrictToOwnHistory && (
                        <>
                            <label className="col-md-4">
                                <div className="d-flex align-items-center" style={{ margin: '10px 0' }}>
                                    <span>{historyHeader.sip[+localStorage.getItem('atsLang') || 1]}</span>
                                    <HistorySelect handleChange={handleChange} select={select.sip} query={query} />
                                </div>
                            </label>
                            <label className="col-md-4">
                                <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                                    <span>{historyHeader.included[+localStorage.getItem('atsLang') || 1]}</span>
                                    <HistorySelect handleChange={handleChange} select={select.allowed} query={query} />
                                </div>
                            </label>
                        </>
                    )}
                    <label className="col-md-4">
                        <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                            <span>{graphics['rate'][langIndex]}</span>
                            <div style={{ flex: 1 }}>
                                <Select
                                    isSearchable={false}
                                    menuPortalTarget={document.body}
                                    styles={customStyles}
                                    value={selectedRate}
                                    className="basic-single w-100"
                                    classNamePrefix="select"
                                    onChange={(opt) => handleChange('rate', { target: { value: opt?.value || '' } })}
                                    options={rateOptions}
                                />
                            </div>
                        </div>
                    </label>
                </div>
            </div>
            <div className="col-md-1 d-flex flex-column align-items-end">
                <button className="addBtnBig" onClick={handleSubmit} style={{
                    fontSize: 11,
                    padding: '10px 17px', marginTop: 4
                }}>
                    {input.search[+localStorage.getItem('atsLang') || 1]}
                </button>
            </div>
            {!restrictToOwnHistory && showExtraFilters && (
                <div className="col-md-11" style={{ marginTop: 10 }}>
                    <div className="row history_page">
                        <label className="col-md-4">
                            <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                                <span>{historyHeader.short_number[+localStorage.getItem('atsLang') || 1]}</span>
                                <div style={{ flex: 1 }}>
                                    <Select
                                        isSearchable
                                        menuPortalTarget={document.body}
                                        styles={customStyles}
                                        value={selectedVirtual}
                                        className="basic-single w-100"
                                        classNamePrefix="select"
                                        onChange={(opt) => handleChange('virtual', { target: { value: opt?.value || '' } })}
                                        options={virtualOptions}
                                    />

                                </div>
                            </div>
                        </label>
                        <label className="col-md-4">
                            <div className="d-flex align-items-start" style={{ margin: '10px 0' }}>
                                <span>{employee.short_number_label[+localStorage.getItem('atsLang') || 1]}</span>
                                <div style={{ flex: 1 }}>
                                    <Select
                                        isSearchable
                                        menuPortalTarget={document.body}
                                        styles={customStyles}
                                        value={selectedShort}
                                        className="basic-single w-100"
                                        classNamePrefix="select"
                                        onChange={(opt) => handleChange('virtual', { target: { value: opt?.value || '' } })}
                                        options={shortsOptions}
                                    />

                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            )}
        </form>
    );
}

export default HistoryFilter;
